import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo, faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from './EmptyData.module.scss';

const EmptyData = (props) => {
  return (
    <div className={styles.empty}>
      <div className="icons_empty">
        <div className="icons">
          <FontAwesomeIcon className="info_icon" icon={faInfo} color="#dfdfdf" />
          <FontAwesomeIcon className="search_icon" icon={faSearch} color="#dfdfdf" rotation={90} />
        </div>
      </div>
      <big>{props.text}</big>
    </div>
  );
};

export default EmptyData;
